export default __webpack_public_path__ + "static/media/img_team_manager-2.ce384bf7.png";